import * as Primitive from '@radix-ui/react-tooltip';
import type { ReactElement, ReactNode } from 'react';

/// Dica em texto ao pousar o ponteiro ou ao focar pelo teclado. Abre na hora: quem pousa o ponteiro
/// já está procurando a informação.
///
/// Não é o `title` do navegador: aquele demora quase um segundo para aparecer, não respeita o tema,
/// muda de aparência a cada sistema e não abre no foco por teclado. Este abre também no foco, que é
/// o que torna um botão só de ícone utilizável sem mouse.
///
/// A dica NUNCA é a única fonte do rótulo: quem usa botão só de ícone continua obrigado a dar um
/// nome acessível a ele. Aqui a dica é a versão visível desse nome, para quem enxerga.
export function Tooltip({
  content,
  children,
  side = 'top',
}: {
  content: ReactNode;
  children: ReactElement;
  side?: 'top' | 'right' | 'bottom' | 'left';
}) {
  return (
    <Primitive.Provider delayDuration={0} skipDelayDuration={300}>
      <Primitive.Root>
        <Primitive.Trigger asChild>{children}</Primitive.Trigger>
        <Primitive.Portal>
          <Primitive.Content
            side={side}
            sideOffset={6}
            className="z-50 max-w-64 rounded-lg border border-surface-border bg-surface-card px-2.5 py-1.5 text-xs font-medium text-content shadow-[0_8px_24px_rgb(0_0_0/.45)] data-[state=delayed-open]:animate-[modal-in_.12s_ease-out]"
          >
            {content}
            <Primitive.Arrow className="fill-surface-card" />
          </Primitive.Content>
        </Primitive.Portal>
      </Primitive.Root>
    </Primitive.Provider>
  );
}
